(() => {
  const configNode = document.getElementById('fiive-merchandising-config');
  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch {}
  const localIds = new Set(config.localIds || []);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const isGift = product => Array.isArray(product?.tags) && product.tags.includes('fp:free-gift') && !product.tags.some(tag => ['fp:extra','fp:subscription','fp:service','fp:warranty','mws_fee_generated'].includes(tag));
  const prices = (product, variant = {}) => {
    const regular = Number(variant.price ?? product.price ?? 0);
    const comparison = Number(variant.id ? (variant.compare_at_price ?? 0) : (product.compare_at_price ?? 0));
    return {gift:isGift(product),price:isGift(product) ? 0 : regular,compare:Math.max(isGift(product) ? regular : 0, comparison)};
  };
  const giftNote = () => '<small class="fp-gift-price-note">'+escape(config.giftNote)+'</small>';
  const localBadge = product => {
    if (!product?.available || !localIds.has(String(product.id).split('/').pop())) return '';
    return '<span class="fp-local-badge" data-fp-local-badge title="'+escape(config.localDescription)+'"><span class="fp-dc-extra__mark">fiive<span>+</span></span><em class="fp-dc-extra__brand">extra</em><span class="fp-dc-extra__benefit">'+escape(config.localLabel)+'</span></span>';
  };
  window.FiiveMerchandising = {isGift, prices, giftNote, localBadge};
})();
